import { Feature, FeatureFlag } from './types';

export const FEATURES = {
  [Feature.PaidProduct]: FeatureFlag.Preview,
  [Feature.PaidProductUi]: FeatureFlag.Preview,
  [Feature.PersonnelDirectory]: FeatureFlag.Preview,
};
